// extracted by mini-css-extract-plugin
module.exports = {"waves":"waves_waves__0Axja"};